module.exports = __webpack_public_path__ + "img/locked.7e13f267.png";